import { FunctionComponent } from "react";
import "./LabeledInput.css";

interface IProps {
	children: React.ReactNode;
	label: string;
}

const LabeledInput: FunctionComponent<IProps> = (props) => {
	const { children, label } = props;

	return <div className="labeledInput">
		<label>
			{label}
		</label>
		{children}
	</div>;
}

export default LabeledInput;